var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.395264 1.38891V8.95885C0.395264 9.75518 1.04082 10.4007 1.83716 10.4007C1.43899 10.4007 1.11621 9.75518 1.11621 8.95885V1.38891H6.88378V10.4007H7.60472V1.38891C7.60472 0.990747 7.28195 0.667969 6.88378 0.667969H1.11621C0.718042 0.667969 0.395264 0.990747 0.395264 1.38891Z",
    fill: "#C0C0CB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.88378 2.32474C6.88378 1.69231 6.24937 1.2566 5.65909 1.48363L3.14965 2.4488C3.01043 2.50234 2.91857 2.63609 2.91857 2.78524V9.00441C2.91857 9.15357 3.01043 9.28732 3.14965 9.34086L6.3939 10.5886C6.63001 10.6795 6.88378 10.5052 6.88378 10.2522V2.32474ZM5.40028 0.810735C6.46278 0.402082 7.60472 1.18636 7.60472 2.32474V10.2522C7.60472 11.0111 6.84343 11.534 6.1351 11.2615L2.89084 10.0138C2.47321 9.85312 2.19763 9.45187 2.19763 9.00441V2.78524C2.19763 2.33778 2.47321 1.93653 2.89084 1.7759L5.40028 0.810735Z",
    fill: "#C0C0CB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.02024 2.11233C2.74182 2.21942 2.5581 2.48692 2.5581 2.78522V8.28345C2.5581 8.58175 2.74182 8.84925 3.02024 8.95634L6.2645 10.2041C6.73672 10.3858 7.24425 10.0372 7.24425 9.53124V2.32472C7.24425 1.43932 6.35607 0.829319 5.52969 1.14716L3.02024 2.11233ZM3.27905 5.89483C3.27905 6.09391 3.44044 6.2553 3.63952 6.2553C3.8386 6.2553 3.99999 6.09391 3.99999 5.89483V5.17388C3.99999 4.9748 3.8386 4.81341 3.63952 4.81341C3.44044 4.81341 3.27905 4.9748 3.27905 5.17388V5.89483Z",
    fill: "#C0C0CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoor);
export default __webpack_public_path__ + "static/media/door.0852c010aab5f709dbbea450867efd0e.svg";
export { ForwardRef as ReactComponent };